import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "components-font-awesome/css/all.css"
// components imports
import {BootstrapVue} from 'bootstrap-vue';
Vue.use(BootstrapVue);
// import { BootstrapVueIcons } from 'bootstrap-vue'
// Vue.use(BootstrapVueIcons)

import Highcharts from 'highcharts'
Vue.use(Highcharts)

import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);

import itemseriesInit from 'highcharts/modules/item-series'

itemseriesInit(Highcharts)

import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue, {tagName: 'highcharts'})

import JQuery from 'jquery'
let $ = JQuery
// css imports
// import Swiper from 'swiper';
import "swiper/js/swiper.js";
import "swiper/css/swiper.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'

import excel from 'vue-excel-export'
Vue.use(excel)

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
Vue.component('date-picker',DatePicker)

//form validations start
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

require("@/assets/css/responsive.css");
require("@/assets/css/style.css");

import { ClientTable } from "vue-tables-2";
Vue.use(ClientTable);

import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {}
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
  // fallbackLocale: 'en',
})

// i18n.locale = 'en'
// new Vue({ i18n }).$mount('#app')

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.component("Loading", Loading);

// import jquery from 'jquery';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import Loader from './components/layout/Loader';
import Footer from './components/layout/Footer';

Vue.component("Header", Header);
Vue.component("Sidebar",Sidebar);
Vue.component("Loader", Loader);
Vue.component("Footer", Footer);

Vue.config.productionTip = false;



new Vue({
  data(){
    return{
      isLoading: false,
      loaderType: 'dots',
      color: '#6094FC',
      localLang:'en'
    }
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

$(document).ready(function () {
  $('#sidebarCollapse').on('click', function () {
      $('#sidebar').toggleClass('active');
      $('#content').toggleClass('active');
  });
  
});